import React, { Component } from 'react';
import { Result, Icon } from 'antd-mobile';
import { createBrowserHistory } from "history";
import './style.less';
const history = createBrowserHistory();
export default class QuanrenResult extends Component {
    constructor(props) {
        super(props);
        this.state = {
            resultData: [],
            pagename: this.props.match.params.pagename,
            resultnum: this.props.match.params.resultnum,
            errornum: 0,
            errormessage: '',
        }
    }
    render() {
        const { resultnum, pagename } = this.state;
        return <div className="quanrenResult" style={{ minHeight: document.documentElement.clientHeight }}>            {
            pagename === 'integraltransfer' ?
                <div>
                    {parseInt(resultnum) === 0 ?
                        <div>

                            <Result
                                img={<Icon type="check-circle" className="spe" style={{ fill: '#32a128', fontSize: '26px' }} />}
                                title="执行成功"
                            />
                            <div className="resultbox">
                            预计10分钟到您的积分列表
                            </div>
                            

                        </div>
                        :
                        <div>
                            <Result
                                img={<Icon type="cross-circle-o" className="spe" style={{ fill: '#F13642' }} />}
                                title="执行失败"
                            />
                             <div className="resultbox">
                            预计10分钟到您的积分列表
                            </div>

                        </div>
                    }
                    <div className="buts">
                        <button className="but" onClick={() => {
                            history.goBack();
                        }}>返回</button>
                        <button className="but" onClick={() => {
                            history.push('/members/integral');
                            history.go();
                        }}>积分中心</button>
                    </div>



                </div>
                : ''

        }
        </div>;
    }
}